/* snifz-pages.js — loaded on all pages */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ── Nav scroll ── */
    var nav = document.getElementById('nav');
    if (nav) {
      window.addEventListener('scroll', function () {
        nav.classList.toggle('scrolled', window.scrollY > 40);
      }, { passive: true });
    }

    /* ── Offset nav below the announcement bar only when it's actually rendered ── */
    var announcementBar = document.querySelector('.snifz-announcement-bar');
    if (nav) {
      nav.style.top = announcementBar ? announcementBar.offsetHeight + 'px' : '0px';
    }

    /* ── Mobile menu ── */
    var hamburger = document.querySelector('.hamburger');
    var mobileMenu = document.querySelector('.mobile-menu');
    var mobileClose = document.querySelector('.mobile-close');
    if (hamburger && mobileMenu) {
      hamburger.addEventListener('click', function () {
        mobileMenu.classList.add('open');
        document.body.classList.add('mobile-menu-open');
        document.body.style.overflow = 'hidden';
        if (window.snifzLenis) window.snifzLenis.stop();
        if (window.ScrollTrigger) {
          window.ScrollTrigger.getAll().forEach(function (st) { st.disable(false); });
        }
      });
    }
    if (mobileClose && mobileMenu) {
      mobileClose.addEventListener('click', function () {
        mobileMenu.classList.remove('open');
        document.body.classList.remove('mobile-menu-open');
        document.body.style.overflow = '';
        if (window.snifzLenis) window.snifzLenis.start();
        if (window.ScrollTrigger) {
          window.ScrollTrigger.getAll().forEach(function (st) { st.enable(); });
        }
      });
    }
    document.querySelectorAll('.mobile-submenu-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('open');
        var sub = btn.nextElementSibling;
        if (sub) sub.classList.toggle('open');
      });
    });

    /* ── Product gallery thumbs ── */
    var mainImg = document.getElementById('mainImg');
    if (mainImg) {
      document.querySelectorAll('.gallery-thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          mainImg.src = thumb.dataset.src;
          if (thumb.dataset.fullSrc) mainImg.dataset.fullSrc = thumb.dataset.fullSrc;
        });
      });
    }

    /* ── Product image lightbox ── */
    var galleryMain = document.getElementById('galleryMain');
    var lightbox = document.getElementById('imageLightbox');
    var lightboxImg = document.getElementById('imageLightboxImg');
    var lightboxClose = document.getElementById('imageLightboxClose');
    var lightboxThumbs = document.querySelectorAll('.image-lightbox-thumb');
    if (galleryMain && lightbox && lightboxImg && mainImg) {
      function setLightboxActiveThumb(fullSrc) {
        lightboxThumbs.forEach(function (t) {
          t.classList.toggle('active', t.dataset.fullSrc === fullSrc);
        });
      }
      galleryMain.addEventListener('click', function () {
        var fullSrc = mainImg.dataset.fullSrc || mainImg.src;
        lightboxImg.src = fullSrc;
        lightboxImg.alt = mainImg.alt;
        setLightboxActiveThumb(fullSrc);
        lightbox.removeAttribute('hidden');
        requestAnimationFrame(function () { lightbox.classList.add('open'); });
        document.body.style.overflow = 'hidden';
      });
      lightboxThumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          lightboxImg.src = thumb.dataset.fullSrc;
          lightboxImg.alt = thumb.querySelector('img').alt;
          setLightboxActiveThumb(thumb.dataset.fullSrc);
          /* keep the main gallery in sync so it matches after closing */
          mainImg.src = thumb.dataset.src;
          mainImg.dataset.fullSrc = thumb.dataset.fullSrc;
          mainImg.alt = thumb.querySelector('img').alt;
          document.querySelectorAll('.gallery-thumb').forEach(function (t) {
            t.classList.toggle('active', t.dataset.fullSrc === thumb.dataset.fullSrc);
          });
        });
      });
      function closeLightbox() {
        lightbox.classList.remove('open');
        document.body.style.overflow = '';
        setTimeout(function () { lightbox.setAttribute('hidden', ''); }, 220);
      }
      if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lightbox.classList.contains('open')) closeLightbox();
      });
    }

    /* ── Product videos slider (prev/next arrows) ── */
    var videosGrid = document.getElementById('productVideosGrid');
    var videosPrev = document.getElementById('productVideosPrev');
    var videosNext = document.getElementById('productVideosNext');
    if (videosGrid && videosPrev && videosNext) {
      var videoScrollStep = function () {
        var card = videosGrid.querySelector('.product-video-card');
        var gap = parseFloat(getComputedStyle(videosGrid).gap) || 24;
        return card ? card.getBoundingClientRect().width + gap : 224;
      };
      videosPrev.addEventListener('click', function () {
        videosGrid.scrollBy({ left: -videoScrollStep(), behavior: 'smooth' });
      });
      videosNext.addEventListener('click', function () {
        videosGrid.scrollBy({ left: videoScrollStep(), behavior: 'smooth' });
      });
    }

    /* ── Product tabs ── */
    var tabBtns = document.querySelectorAll('.tab-btn');
    if (tabBtns.length) {
      tabBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          tabBtns.forEach(function (b) { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');
          document.querySelectorAll('.tab-pane').forEach(function (pane) { pane.classList.remove('active'); });
          var target = document.getElementById('tab-' + btn.dataset.tab);
          if (target) target.classList.add('active');
        });
      });
    }

    /* ── Variant chip selection + WA button SKU update ── */
    var waBtn = document.getElementById('waEnquireBtn');
    document.querySelectorAll('.variant-chip-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = btn.dataset.optionIndex;
        document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var labelEl = document.getElementById('selectedVal' + (parseInt(idx, 10) + 1));
        if (labelEl) labelEl.textContent = btn.dataset.value;
        if (waBtn) {
          var selectedVariant = btn.dataset.value;
          var title = waBtn.dataset.title;
          var sku = waBtn.dataset.sku;
          var wa = waBtn.dataset.wa;
          var text = "Hi! I'd like to enquire about: " + title + ' (' + selectedVariant + ')' + (sku ? ' SKU: ' + sku : '');
          waBtn.onclick = function () {
            window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
          };
        }
      });
    });

    /* ── Initial WA button handler ── */
    if (waBtn) {
      waBtn.addEventListener('click', function () {
        var title = waBtn.dataset.title;
        var sku = waBtn.dataset.sku;
        var wa = waBtn.dataset.wa;
        var activeVariant = document.querySelector('.variant-chip-btn.active');
        var variantName = activeVariant ? activeVariant.dataset.value : '';
        var text = "Hi! I'd like to enquire about: " + title + (variantName ? ' (' + variantName + ')' : '') + (sku ? ' — SKU: ' + sku : '');
        window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(text), '_blank', 'noopener');
      });
    }

    /* ── Collection filter sidebar accordion ── */
    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('open');
        btn.setAttribute('aria-expanded', btn.classList.contains('open') ? 'true' : 'false');
        var opts = btn.nextElementSibling;
        if (opts) opts.style.display = btn.classList.contains('open') ? '' : 'none';
      });
    });

    /* ── Mobile filter sidebar toggle ── */
    var mobileFilterBtn = document.getElementById('mobileFilterBtn');
    var filterSidebar = document.getElementById('filterSidebar');
    if (mobileFilterBtn && filterSidebar) {
      mobileFilterBtn.addEventListener('click', function () {
        filterSidebar.classList.toggle('open');
      });
    }

    /* ── Sort select → update URL ── */
    var sortSelect = document.getElementById('sortSelect');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        window.location.href = url.toString();
      });
    }

    /* ── Filter form submit on checkbox change ── */
    var filterForm = document.getElementById('filterForm');
    if (!filterForm) {
      // Wrap filter sidebar inputs in a form if not already
      var sidebar = document.getElementById('filterSidebar');
      if (sidebar) {
        sidebar.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
          cb.addEventListener('change', function () {
            var url = new URL(window.location.href);
            var checked = sidebar.querySelectorAll('input[type="checkbox"]:checked');
            // Clear existing filter params
            for (var key of Array.from(url.searchParams.keys())) {
              if (key.startsWith('filter.')) url.searchParams.delete(key);
            }
            checked.forEach(function (c) {
              url.searchParams.append(c.name, c.value);
            });
            window.location.href = url.toString();
          });
        });
      }
    }

  });

})();
